// Imports
import axios from "axios";

import "../../../setup/config/apiConfig";

export const HANDLE_RECEIPTS_SEARCH_REQUEST = "HANDLE_RECEIPTS_SEARCH_REQUEST";
export const HANDLE_RECEIPTS_SEARCH_RESPONSE = "HANDLE_RECEIPTS_SEARCH_RESPONSE";
export const HANDLE_RECEIPTS_SEARCH_FAILURE = "HANDLE_RECEIPTS_SEARCH_FAILURE";

export function searchForArReceiptsByFilters({
  page,
  rowsPerPage,
  accountUuid,
  searchQuery,
  isLoading = true,
  isBaseGroup = true,
  resetCache = false,
}) {
  // provide default values because api endpoint breaks otherwise
  var target = "?";
  if (page || page == 0) {
    target = target + "page=" + page + "&";
  }
  if (rowsPerPage && rowsPerPage != null) {
    target = target + "pageLimit=" + rowsPerPage + "&";
  }
  if (searchQuery && searchQuery != "") {
    target = target + "searchQuery=" + encodeURIComponent(searchQuery) + "&";
  }
  if (accountUuid && accountUuid != null) {
    target = target + "accountUuid=" + accountUuid + "&";
  }
  return (dispatch) => {
    dispatch({
      type: HANDLE_RECEIPTS_SEARCH_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .get("/get-ar-reciepts-filtered/" + target)
      .then((response) => {
        let error = "";
        if (response.data.errors && response.data.errors.length > 0) {
          error = response.data.errors[0].message;
        }

        // Update/Check if user object is the obj state
        const currentUser = JSON.parse(window.localStorage.getItem("user"));
        if (currentUser) {
          // if current user is still logged in and valid, update ar reciepts table with new results
          dispatch({
            type: HANDLE_RECEIPTS_SEARCH_RESPONSE,
            searchResponse: response.data,
            isBaseGroup: isBaseGroup,
            resetCache: resetCache,
            isLoading: false,
            error: error,
          });
        } else {
          // if no user is found then clear object because its an unauthorized access
          dispatch({
            type: HANDLE_RECEIPTS_SEARCH_RESPONSE,
            isLoading: false,
            error: "ERROR! NO USER LOGGED IN!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: HANDLE_RECEIPTS_SEARCH_FAILURE,
          isLoading: false,
          error: error,
        });
      });
  };
}